// language=GraphQL
export const ALL_PERSONAL_ADDONS_QUERY = `query Query($withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  personalAddons: ratioPersonalAddons {
    id
    ratioServiceNo
    name
    label
    info
    allowedAgeGroups @include(if: $withAllowedAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_PERSONAL_ADDON_QUERY = `query Query($id: ID!, $withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  personalAddon: ratioPersonalAddon(id: $id) {
    id
    ratioServiceNo
    name
    label
    info
    allowedAgeGroups @include(if: $withAllowedAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const CREATE_PERSONAL_ADDON_MUTATION = `
  mutation Mutation($input: CreateRatioPersonalAddonInput, $withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    personalAddon: createRatioPersonalAddon(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      allowedAgeGroups @include(if: $withAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_PERSONAL_ADDON_MUTATION = `
  mutation Mutation($input: UpdateRatioPersonalAddonInput, $withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    personalAddon: updateRatioPersonalAddon(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      allowedAgeGroups @include(if: $withAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_PERSONAL_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioPersonalAddonInput) {
    deleteRatioPersonalAddon(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PERSONAL_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioPersonalAddonInput) {
    forceDeleteRatioPersonalAddon(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: addRatioPersonalAddonAllowedAgeGroupsInput) {
    addRatioPersonalAddonAllowedAgeGroups(input: $input) {
      id
      allowedAgeGroupIds
    }
  }`

// language=GraphQL
export const REMOVE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: removeRatioPersonalAddonAllowedAgeGroupsInput) {
    removeRatioPersonalAddonAllowedAgeGroups(input: $input) {
      id
      allowedAgeGroupIds
    }
  }`

// language=GraphQL
export const CREATE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: createRatioPersonalAddonAllowedAgeGroupsInput) {
    createRatioPersonalAddonAllowedAgeGroups(input: $input) {
      id
      allowedAgeGroupIds
    }
  }`

// language=GraphQL
export const DELETE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: deleteRatioPersonalAddonAllowedAgeGroupsInput) {
    deleteRatioPersonalAddonAllowedAgeGroups(input: $input) {
      id
      allowedAgeGroupIds
    }
  }`

// language=GraphQL
export const PERSONAL_ADDONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravels: Boolean = false, $withTravellers: Boolean = false) {
  groupedDependents: ratioPersonalAddonDependents(id: $id) {
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus
      suppressBusBoardingSelection    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
  }
}`
